/* eslint-disable */
import * as util from "@/api/omniwa";
// import { checkAnomaliBroadcast } from "../../api/omniwa";

const state = {
    detailBroadcast: {},
    broadcastParamSt: { //from state
        form_speed: {
            delay_interval: { wait_min: 0, wait_max: 0 },
            rest_mode: { stop_after: 0, rest_for: 0 },
        },
        error_import: 0,
        success_import: 0,
        is_import: 0,
        speed_mode: "normal",
        speed_wait_min: '0',
        speed_wait_max: '0',
        speed_stop_after: '0',
        speed_rest_for: '0',
        is_custom_url: false,
        rowDetail: {},
        is_duplicate: false,
        broadcast_id: '',
        title: "",
        provider: "whatsapp",
        license_id: '',
        selectedLicense:null,
        to_group: [],
        to: [],
        is_group: 1, //for group set 1, for personal set 0
        is_group_type: "group", //group/tags
        message: {
            text: "",
            message_type: "text", //text,image,document
            file_url: ""
        },
        sending_options: 1,
        sending_schedule: "",
        is_recurring: 0,
        recurring_form: {
            recurrence: "",
            recurrence_time: "00:01",
            recurrence_every: "",
            recurrence_annually_month: "",
            recurrence_end: "never",
            recurrence_end_date: ""
        },
        is_send: 1,
        to_test: "",
        footer_message_status: false,
        footer_message: "",
        buttons: [{id:""}, {id:""}, {id:""}, {id:""}, {id:""}, {id:""}, {id:""}, {id:""}, {id:""}, {id:""}],
        ab_testing_enabled: false,
        variants: [],
        pending_deleted_variant_codes: [],
        pending_deleted_variant_orders: []


    },
    messageTypeOptionsUpload: ["image", "video", "document"],
    messageTypeCurrent: "image",
    sendText: {
        recipient_number: "",
        text: "",
        quoted_id: "",
        quoted_message: ""
    },
    onlyUploadFile: {
        files: null,
        message_type: ""
    },
    objFilesMessageHandler: {
        recipient_number: "",
        id: "",
        text: "",
        quoted_id: "",
        quoted_message: "",
        // message_media: messaegMedia,
        message_type: ""
    },
    broadcastStep:'',
    infoSpeed:null,
    logoutCounter: 0,
};


const mutations = {
    SET_infoSpeed: (state, value) => {
        state.infoSpeed = value
    },
    SET_broadcastStep: (state, value) => {
        state.broadcastStep = value
    },
    SET_detailBroadcast: (state, value) => {
        state.detailBroadcast = value
    },
    SET_broadcastParamSt: (state, value) => {
        state.broadcastParamSt = value
    },
    SET_objFilesMessageHandler: (state, value) => {
        state.objFilesMessageHandler = value
    },
    SET_messageTypeCurrent: (state, value) => {
        state.messageTypeCurrent = value
    },
    SET_sendText: (state, value) => {
        state.sendText = value
    },
    SET_onlyUploadFile: (state, value) => {
        state.onlyUploadFile = value
    },
    SET_logoutCounter: (state) => {
        state.logoutCounter += 1
    },
};

const actions = {
    resendMessagePrepare({ commit }, data) {
        return new Promise((resolve, reject) => {
            util.resendMessagePrepare(data).then(response => {
                // var { data } = response
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    deleteMessagePrepare({ commit }, data) {
        return new Promise((resolve, reject) => {
            util.deleteMessagePrepare(data).then(response => {
                // var { data } = response
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    deleteMessage({ commit }, data) {
        return new Promise((resolve, reject) => {
            util.deleteMessage(data).then(response => {
                // var { data } = response
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    resendMessage({ commit }, data) {
        return new Promise((resolve, reject) => {
            util.resendMessage(data).then(response => {
                // var { data } = response
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    sendQuickReply({ commit }, data) {
        return new Promise((resolve, reject) => {
            util.sendQuickReply(data).then(response => {
                // var { data } = response
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    actBroadcastParamSt({ commit }, data) {
        commit("SET_broadcastParamSt", data);
    },

    detailBroadcastSpeedInfo({ commit }, data) {
        return new Promise((resolve, reject) => {
            util.detailBroadcastSpeedInfo(data).then(response => {
                commit('SET_infoSpeed',response.data)
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    detailButtonsBroadcast({ commit }, data) {
        return new Promise((resolve, reject) => {
            util.detailButtonsBroadcast(data).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    checkAnomaliBroadcast({ commit }, data) {
        return new Promise((resolve, reject) => {
            util.checkAnomaliBroadcast(data).then(response => {
                // var { data } = response
                // commit("SET_detailBroadcast", data);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    resendAnomaliBroadcast({ commit }, data) {
        return new Promise((resolve, reject) => {
            util.resendAnomaliBroadcast(data).then(response => {
                // var { data } = response
                // commit("SET_detailBroadcast", data);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    detailBroadcast({ commit }, data) {
        return new Promise((resolve, reject) => {
            util.detailBroadcast(data).then(response => {
                var { data } = response
                commit("SET_detailBroadcast", data);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    deleteBroadcast({ commit }, data) {
        return new Promise((resolve, reject) => {
            util.deleteBroadcast(data).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    sendBroadcastTest({ commit }, data) {
        return new Promise((resolve, reject) => {
            util.sendBroadcastTest(data).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    sendBroadcastImport({ commit }, data) {
        return new Promise((resolve, reject) => {
            util.sendBroadcastImport(data).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    sendBroadcast({ commit }, data) {
        return new Promise((resolve, reject) => {
            util.sendBroadcast(data).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    actFilesMessageHandler({ commit }, data) {
        commit("SET_objFilesMessageHandler", data);
    },
    sendFile({ commit }, data) {
        return new Promise((resolve, reject) => {
            // util.sendFile(data).then(response => {
            util.sendFileMQ(data).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    sendFilepath({ commit }, data) {
        return new Promise((resolve, reject) => {
            util.sendFilepath(data).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    messageTypeCurrent({ commit }, data) {
        commit("SET_messageTypeCurrent", data);
    },
    onlyUploadFile({ commit }, data) {
        return new Promise((resolve, reject) => {
            util.onlyUploadFile(data).then(response => {
                commit("SET_onlyUploadFile", data);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    sendText({ commit }, data) {
        return new Promise((resolve, reject) => {
            // util.sendText(data).then(response => {
            util.sendTextMQ(data).then(response => {
                commit("SET_sendText", data);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    login({ commit }, id) {
        return new Promise((resolve, reject) => {
            util.login(id).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    isOnline({ commit }, phone) {
        return new Promise((resolve, reject) => {
            util.isOnline(phone).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    logout({ commit }, phone) {
        return new Promise((resolve, reject) => {
            util.logout(phone).then(response => {
                commit("SET_logoutCounter");
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/omniwa.js